import React from 'react';
import PrimaryButton from '../PrimaryButton/PrimaryButton';
import SecondaryButton from '../SecondaryButton/SecondaryButton';
import blackFridayBannerImage from '../../assets/images/banners/blackfriday-banner-3.png';

interface ActionCardProps {
  title?: string;
  description?: string;
  secondaryText?: string;
  primaryAction: { label: string; onClick: () => void };
  secondaryAction?: { label: string; onClick: () => void };
  disabled?: boolean;
}

const BlackFridayBanner: React.FC<ActionCardProps> = ({
  title,
  description,
  secondaryText,
  primaryAction,
  secondaryAction,
  disabled = false,
}) => {
  return (
    <>
      <style>{`
        @media (max-width: 768px) {
          .blackfriday-banner-mobile {
            background-position: 25% center !important;
          }
        }
      `}</style>
      <div 
        className="mx-auto p-12 rounded-lg shadow-md flex items-center justify-between flex-col lg:flex-row text-white h-full min-h-[400px] relative overflow-hidden blackfriday-banner-mobile"
        style={{
          backgroundImage: `url(${blackFridayBannerImage})`,
          backgroundSize: 'cover',
          backgroundPosition: 'center center',
          backgroundRepeat: 'no-repeat',
        }}
      >
      {/* Optional overlay for better text readability */}
      <div className="absolute inset-0 bg-black/10 md:bg-black/10 bg-black/40 z-0"></div>
      
      {/* Promotional Text and Button - Right Side */}
      <div className="flex-1 flex justify-end items-end relative z-10 pr-8 md:pr-16">
        <div className="text-center flex flex-col items-center">
          <div 
            className="font-black leading-none mb-2"
            style={{
              fontSize: 'clamp(3rem, 8vw, 7rem)',
              fontFamily: '"Arial Black", "Arial Bold", Arial, sans-serif',
              fontWeight: 900,
              color: '#ff0000',
              textShadow: '0 0 10px rgba(255, 255, 255, 0.8), 0 0 20px rgba(255, 255, 255, 0.5), 2px 2px 0px #8b0000, -1px -1px 0px #8b0000, 1px -1px 0px #8b0000, -1px 1px 0px #8b0000',
              WebkitTextStroke: '2.5px #8b0000',
              lineHeight: '0.9',
            }}
          >
            {description || "-50%"}
          </div>
          <div 
            className="font-black mb-2"
            style={{
              fontSize: 'clamp(2rem, 5vw, 3.5rem)',
              fontFamily: '"Arial Black", "Arial Bold", Arial, sans-serif',
              fontWeight: 900,
              color: '#ff0000',
              textShadow: '0 0 8px rgba(255, 255, 255, 0.8), 0 0 15px rgba(255, 255, 255, 0.5), 1.5px 1.5px 0px #8b0000, -0.5px -0.5px 0px #8b0000, 0.5px -0.5px 0px #8b0000, -0.5px 0.5px 0px #8b0000',
              WebkitTextStroke: '2px #8b0000',
              lineHeight: '1',
            }}
          >
            {title || "BLACK FRIDAY"}
          </div>
          <div 
            className="font-black mb-4"
            style={{
              fontSize: 'clamp(1.5rem, 3vw, 2.25rem)',
              fontFamily: '"Arial Black", "Arial Bold", Arial, sans-serif',
              fontWeight: 900,
              color: '#ff0000',
              textShadow: '0 0 6px rgba(255, 255, 255, 0.8), 0 0 12px rgba(255, 255, 255, 0.5), 1px 1px 0px #8b0000, -0.5px -0.5px 0px #8b0000, 0.5px -0.5px 0px #8b0000, -0.5px 0.5px 0px #8b0000',
              WebkitTextStroke: '1.5px #8b0000',
              lineHeight: '1.2',
            }}
          >
            {secondaryText || "27.11 - 30.11"}
          </div>
          
          {/* Button below text */}
          <div className="flex flex-col space-y-4">
            <PrimaryButton
              text={primaryAction.label}
              fn={primaryAction.onClick}
              isDisabled={disabled}
            />
            { secondaryAction && <SecondaryButton
              fn={secondaryAction.onClick}
              text={secondaryAction.label}
              isDisabled={disabled}
            /> }
          </div>
        </div>
      </div>
    </div>
    </>
  );
};

export default BlackFridayBanner;

